export enum LEAD_TYPE {
  Concierge = 'Concierge',
  Marketplace = 'Marketplace',
}

export enum INTENT {
  buy = 'buy',
  quote = 'quote',
  interest = 'interest',
}

export enum TERNARY {
  YES = 'YES',
  NO = 'NO',
  MAYBE = 'MAYBE',
}

export enum ATTACHMENT_TYPE {
  SWITCHBOARD = 'SWITCHBOARD',
  ELECTRICITY_BILL = 'ELECTRICITY_BILL',
  GAS_BILL = 'GAS_BILL',
}
